import { useState } from 'react'
import { Button } from '@/components/ui'

/**
 * Both this device and another edited the page before they synced. Nothing has
 * been overwritten yet; the person decides, or lets the assistant merge.
 */
export const ConflictBanner = ({
  theirs,
  assistant,
  onKeepMine,
  onTakeTheirs,
  onMerge,
}: {
  theirs: unknown[]
  assistant: boolean
  onKeepMine: () => void
  onTakeTheirs: () => void
  onMerge: () => Promise<void>
}) => {
  const [busy, setBusy] = useState(false)
  const [err, setErr] = useState<string | null>(null)
  return (
    <div
      className="mb-3 rounded-xl border border-amber-500/40 bg-amber-500/10 px-3 py-2.5 text-sm fade-in"
      role="alert"
      data-testid="page-conflict"
    >
      <div className="font-medium text-amber-200">
        This page changed on another device while you were editing.
      </div>
      <p className="text-xs text-amber-100/80 mt-0.5">
        Neither version has been thrown away. Keep what's here, take the other version ({theirs.length}{' '}
        blocks), or let the assistant merge both.
      </p>
      {err && <p className="text-xs text-rose-300 mt-1">{err}</p>}
      <div className="flex flex-wrap gap-1.5 mt-2">
        <Button variant="chip" onClick={onKeepMine} disabled={busy} data-testid="conflict-mine">
          Keep mine
        </Button>
        <Button variant="chip" onClick={onTakeTheirs} disabled={busy} data-testid="conflict-theirs">
          Take theirs
        </Button>
        {assistant && (
          <Button
            variant="chipOn"
            disabled={busy}
            data-testid="conflict-merge"
            onClick={() => {
              setBusy(true)
              setErr(null)
              onMerge()
                .catch((e: Error) => setErr(e.message))
                .finally(() => setBusy(false))
            }}
          >
            {busy ? 'Merging…' : '✨ Merge with AI'}
          </Button>
        )}
      </div>
    </div>
  )
}
